<template>
    <div>
      <Bar :data="data" :options="options" />
    </div>
  </template>
  
  <script>
    import { Bar } from 'vue-chartjs'

  export default {
    name: 'BarChart',
    components: { Bar },
    props: {
      data: {
        type: Object,
        required: true
      },
      options: {
        type: Object,
        required: true
      }
    }
  }
  </script>
  
  <style scoped>
  canvas {
    max-width: 100%;
  }
  </style>
  